import { render, staticRenderFns } from "./DefaultFooter.vue?vue&type=template&id=7828c93a"
import script from "./DefaultFooter.vue?vue&type=script&lang=js"
export * from "./DefaultFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports